import * as React from "react";
import Utils from "../../helper/utils";
import DashboardImportacaoCharts from "./dashboard";
import DashboardImportTopo from "./topo";

import { useTranslation } from "react-i18next";

export const DashboardImportPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.dashboardImport.text.import"), "- Dashboard");

  return (
    <React.Fragment>
      <DashboardImportTopo />
      <DashboardImportacaoCharts />
    </React.Fragment>
  );
};